export function getIndexInRange(index: number, max: number): number {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
